<template>
  <v-navigation-drawer
    width="100%"
    fixed
    app
    floating
    :expand-on-hover="mini"
    :value="drawer"
    :right="$vuetify.rtl"
    class="my-4 ms-4 border-radius-lg"
    :class="!$vuetify.breakpoint.mobile ? '' : 'bg-white'"
    :data-color="sidebarColor"
    :data-theme="sidebarTheme"
  >
    <template v-if="$store.state.userData">
      <div class="d-flex flex-row">
        <v-img src="@/assets/img/logo-ct.png" max-height="48" max-width="48">
        </v-img>
        <p
          class="ms-2 font-weight-bold text-sm"
          v-if="$store.state.userData != null"
        >
          Сайн байна уу? <br />{{ $store.state.userData.firstName }}
          <span class="text-secondary">({{ $store.state.userData.role }})</span>
        </p>
        <p v-if="$store.state.userData && $store.state.userData.school">
          {{ $store.state.userData.school.homeSchool }}
        </p>
        <p v-else>
          {{ $store.state.userData.school }}
        </p>
      </div>
      <p>{{ $store.state.userData.email }}</p>
      <p
        class="blue--text"
        v-if="
          $store.state.userData.school &&
          $store.state.userData.roleName != 'superAdmin'
        "
      >
        {{ $store.state.userData.school.name }}
      </p>
      <p v-if="$store.state.userData.role == 'superadmin'">
        {{ $store.state.userData.ref.path }}
      </p>
      <v-select
        v-if="
          $store.state.availableSchools &&
          $store.state.userData.role == 'superadmin'
        "
        :items="$store.state.availableSchools"
        item-text="name2"
        item-value="ref.path"
        v-model="selectedSchool"
        clearable
        label="Сургуулиа сонгох"
      ></v-select>
      <hr class="horizontal dark mb-4" />
    </template>
    <v-list nav dense>
      <v-list-group
        :ripple="false"
        v-for="item in menues"
        :key="item.title"
        v-model="item.active"
        append-icon="fas fa-angle-down"
        class="pb-1 mx-2"
        active-class="item-active"
      >
        <template v-slot:activator>
          <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
            <div v-html="item.action">
              {{ item.action }}
            </div>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              v-text="item.title"
              class="ms-1"
            ></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          :ripple="false"
          link
          class="mb-0 no-default-hover"
          v-for="child in item.items"
          :key="child.title + '-' + child.id"
          :to="child.link"
        >
          <span class="v-list-item-mini" v-text="child.prefix"></span>

          <v-list-item-content class="ms-6 ps-7" v-if="!child.items">
            <v-list-item-title
              v-text="child.title"
              @click="listClose($event)"
            ></v-list-item-title>
          </v-list-item-content>

          <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
            <v-list-group
              prepend-icon=""
              :ripple="false"
              sub-group
              no-action
              v-model="child.active"
            >
              <template v-slot:activator>
                <span class="v-list-item-mini">{{ child.prefix }}</span>
                <v-list nav dense class="pa-0">
                  <v-list-group
                    :ripple="false"
                    append-icon="fas fa-angle-down me-auto ms-1"
                    active-class="item-active"
                    class="mb-0"
                  >
                    <template v-slot:activator class="mb-0">
                      <v-list-item-content class="py-0">
                        <v-list-item-title
                          v-text="child.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-group>
                </v-list>
              </template>
              <v-list-item
                v-for="child2 in child.items"
                :ripple="false"
                :key="child2.title"
                :to="child2.link"
                @click="listClose($event)"
              >
                <span class="v-list-item-mini" v-text="child2.prefix"></span>
                <v-list-item-content>
                  <v-list-item-title v-text="child2.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <template v-if="userData && userData.role == 'superadmin'">
        <v-list-group
          :ripple="false"
          v-for="item in settingMenus"
          :key="item.title"
          v-model="item.active"
          append-icon="fas fa-angle-down"
          class="pb-1 mx-2"
          active-class="item-active"
        >
          <template v-slot:activator>
            <v-list-item-icon class="shadow border-radius-md mx-2 align-center">
              <div v-html="item.action">
                {{ item.action }}
              </div>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.title"
                class="ms-1"
              ></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            :ripple="false"
            link
            class="mb-0 no-default-hover"
            :class="child.active ? 'item-active' : ''"
            v-for="child in item.items"
            :key="child.title"
            :to="child.link"
          >
            <span class="v-list-item-mini" v-text="child.prefix"></span>

            <v-list-item-content class="ms-6 ps-7" v-if="!child.items">
              <v-list-item-title
                v-text="child.title"
                @click="listClose($event)"
              ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-content class="ms-6 ps-7 py-0" v-if="child.items">
              <v-list-group
                prepend-icon=""
                :ripple="false"
                sub-group
                no-action
                v-model="child.active"
              >
                <template v-slot:activator>
                  <span class="v-list-item-mini">{{ child.prefix }}</span>
                  <v-list nav dense class="pa-0">
                    <v-list-group
                      :ripple="false"
                      append-icon="fas fa-angle-down me-auto ms-1"
                      active-class="item-active"
                      class="mb-0"
                    >
                      <template v-slot:activator class="mb-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title
                            v-text="child.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-group>
                  </v-list>
                </template>

                <v-list-item
                  v-for="child2 in child.items"
                  :ripple="false"
                  :key="child2.title"
                  :to="child2.link"
                  @click="listClose($event)"
                >
                  <v-list-item-content>
                    <span
                      class="v-list-item-mini"
                      v-text="child2.prefix"
                    ></span>
                    <v-list-item-title
                      v-text="child2.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>

    <v-card
      class="pa-0 border-radius-lg mt-7 mb-9 mx-4"
      :style="`background-image: url(${require('../assets/img/curved-images/white-curved.jpeg')}); background-size: cover;`"
    >
      <span
        class="mask opacity-8 border-radius-lg"
        :class="`bg-gradient-` + sidebarColor"
      ></span>
      <div class="px-4 py-4 position-relative">
        <v-avatar
          color="bg-white"
          class="shadow"
          width="32"
          height="32"
          min-width="32"
          rounded
        >
          <v-icon
            size="20"
            class="text-gradient"
            :class="`text-` + sidebarColor"
          >
            ni ni-diamond
          </v-icon>
        </v-avatar>
        <div class="docs-info">
          <v-card-text class="text-white text-h6 ps-0 pb-0"
            >Тусламж?</v-card-text
          >
          <v-card-subtitle class="text-white text-xs font-weight-bold pt-0 ps-0"
            >Заавар танилцуулгатай танилцаарай</v-card-subtitle
          >
        </div>
      </div>
    </v-card>
  </v-navigation-drawer>
</template>
<script>
import { sync } from "vuex-pathify";
import { store } from "@/store.js";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ddd",
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    sidebarColor: {
      type: String,
      default: "success",
    },
    sidebarTheme: {
      type: String,
      default: "transparent",
    },
  },

  data: () => ({
    mini: false,
    togglerActive: false,
    thirdLevelSimple: [
      "Third level menu",
      "Just another link",
      "One last link",
    ],
    items: null,
    menues: null,
    settingMenus: null,
    selectedSchool: store.state.selectedSchoolRef,
  }),
  computed: {
    ...sync("*"),
  },
  watch: {
    userData() {},
    selectedSchool(val) {
      store.set("selectedSchoolRef", val);
      if (this.$route.path != "/pages/dashboards/default")
        this.$router.replace("/").then(() => {
          location.reload();
        });
      else location.reload();
    },
  },
  created() {
    if (this.userData && this.userData.role != "cookingadmin") {
      this.menues = [
        {
          action:
            '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
          active: true,
          title: "Home",
          items: [
            {
              title: "Нүүр xуудас",
              prefix: "D",
              link: "/pages/dashboards/default",
            },
          ],
        },
      ];
      if (this.userData.role != "student") {
        this.menues.push({
          action:
            '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
          active: true,
          title: "Бүртгэл",
          items: [],
          shortName: "others",
        });
      }
      this.menues.push({
        action:
          '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
        active: true,
        title: "Сорилууд",
        items: [],
        shortName: "others",
      });
    }
    if (this.userData && this.userData.roleRef) {
      this.userData.roleRef
        .collection("accesses")
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            if (doc.data() && doc.data().ref) {
              doc
                .data()
                .ref.get()
                .then((mitem) => {
                  this.addMenu(mitem.data());
                });
            }
          });
        });
    }
    if (this.userData && this.userData.role == "teacher") {
      this.menues = [
        {
          action:
            '<svg width="12px" height="12px" viewBox="0 0 45 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>shop </title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1716.000000, -439.000000)" fill="#FFFFFF" fill-rule="nonzero"><g transform="translate(1716.000000, 291.000000)"><g transform="translate(0.000000, 148.000000)"><path class="color-background" d="M46.7199583,10.7414583 L40.8449583,0.949791667 C40.4909749,0.360605034 39.8540131,0 39.1666667,0 L7.83333333,0 C7.1459869,0 6.50902508,0.360605034 6.15504167,0.949791667 L0.280041667,10.7414583 C0.0969176761,11.0460037 -1.23209662e-05,11.3946378 -1.23209662e-05,11.75 C-0.00758042603,16.0663731 3.48367543,19.5725301 7.80004167,19.5833333 L7.81570833,19.5833333 C9.75003686,19.5882688 11.6168794,18.8726691 13.0522917,17.5760417 C16.0171492,20.2556967 20.5292675,20.2556967 23.494125,17.5760417 C26.4604562,20.2616016 30.9794188,20.2616016 33.94575,17.5760417 C36.2421905,19.6477597 39.5441143,20.1708521 42.3684437,18.9103691 C45.1927731,17.649886 47.0084685,14.8428276 47.0000295,11.75 C47.0000295,11.3946378 46.9030823,11.0460037 46.7199583,10.7414583 Z" opacity="0.598981585"></path><path class="color-background" d="M39.198,22.4912623 C37.3776246,22.4928106 35.5817531,22.0149171 33.951625,21.0951667 L33.92225,21.1107282 C31.1430221,22.6838032 27.9255001,22.9318916 24.9844167,21.7998837 C24.4750389,21.605469 23.9777983,21.3722567 23.4960833,21.1018359 L23.4745417,21.1129513 C20.6961809,22.6871153 17.4786145,22.9344611 14.5386667,21.7998837 C14.029926,21.6054643 13.533337,21.3722507 13.0522917,21.1018359 C11.4250962,22.0190609 9.63246555,22.4947009 7.81570833,22.4912623 C7.16510551,22.4842162 6.51607673,22.4173045 5.875,22.2911849 L5.875,44.7220845 C5.875,45.9498589 6.7517757,46.9451667 7.83333333,46.9451667 L19.5833333,46.9451667 L19.5833333,33.6066734 L27.4166667,33.6066734 L27.4166667,46.9451667 L39.1666667,46.9451667 C40.2482243,46.9451667 41.125,45.9498589 41.125,44.7220845 L41.125,22.2822926 C40.4887822,22.4116582 39.8442868,22.4815492 39.198,22.4912623 Z"></path></g></g></g></g></svg>',
          active: true,
          title: "Home",
          items: [
            {
              title: "Нүүр xуудас",
              prefix: "D",
              link: "/pages/dashboards/default",
            },
          ],
        },
      ];
      this.menues[0].items.push({
        title: "Xичээлүүд",
        prefix: "S",
        link: "/pages/dashboards/lessons",
      });

      this.menues[0].items.push({
        title: "Миний сорилын сан",
        prefix: "S",
        link: "/pages/dashboards/myassignments",
      });
      if (this.userData.schoolIndex) {
        this.menues[0].items.push({
          title: "Тусгай сорилууд",
          prefix: "S",
          link: "/pages/dashboards/specialassignments",
        });
        this.menues[0].items.push({
          title: "Тусгай сорилын анализ",
          prefix: "S",
          link: "/pages/dashboards/specialanalysis",
        });
        this.menues[0].items.push({
          title: "Тусгай сурагчийн анализ",
          prefix: "S",
          link: "/pages/dashboards/studenteyeshspecialanalysis",
        });
      }

      // this.menues[0].items.push({
      //   title: "ЭЕШ800 сорилууд",
      //   prefix: "S",
      //   link: "/pages/dashboards/pagesorilassignmentsbygrandit",
      // });
      if (this.userData.schoolIndex) {
        this.menues[0].items.push({
          title: "ЭЕШ800 сургуулийн анализ",
          prefix: "S",
          link: "/pages/dashboards/eyeshanalysis",
        });
      }
      // this.menues[0].items.push({
      //   title: "ЭЕШ800 сурaгчийн анализ",
      //   prefix: "S",
      //   link: "/pages/dashboards/studenteyeshanalysis",
      // });
      // this.menues[0].items.push({
      //   title: "ЭЕШ800 Тойм",
      //   prefix: "S1",
      //   link: "/pages/dashboards/scoreanalysis",
      // });
      // this.menues[0].items.push({
      //   title: "ЭЕШ800 зөвлөмж",
      //   prefix: "S1",
      //   link: "/pages/dashboards/questionanalysis",
      // });
    }

    if (this.userData && this.userData.role == "superadmin") {
      this.menues[1].items.push({
        title: "Сургууль бүртгэx",
        prefix: "S1",
        link: "/schoolregistration",
      });
      this.menues[1].items.push({
        title: "Суурь өгөгдөл",
        prefix: "A",
        link: "/settingtables",
      });
    }
    if (this.userData && this.userData.role == "aspecialist") {
      this.menues[0].items.push({
        title: "Xяналтын самбар",
        prefix: "S1",
        link: "/eyeshanalysis",
      });
      this.menues[0].items.push({
        title: "Xичээлүүд",
        prefix: "S",
        link: "/pages/dashboards/lessons",
      });

      this.menues[1].items.push({
        title: "Мэргэжилтэн Бүртгэл",
        prefix: "A",
        link: "/pages/pages/employeessuper",
      });
      this.menues[2].items.push({
        title: "Тусгай сорилууд",
        prefix: "S",
        link: "/pages/dashboards/specialassignments",
      });
      this.menues[2].items.push({
        title: "Тусгай сорилын анализ",
        prefix: "S",
        link: "/pages/dashboards/specialanalysis",
      });

      this.menues[2].items.push({
        title: "ЭЕШ800 Сургуулийн анализ",
        prefix: "S",
        link: "/pages/dashboards/eyeshanalysis",
      });
      this.menues[2].items.push({
        title: "ЭЕШ800 сорилууд",
        prefix: "S",
        link: "/pages/dashboards/pagesorilassignmentsbygrandit",
      });
      this.menues[2].items.push({
        title: "ЭЕШ800 анализ",
        prefix: "S1",
        link: "/pages/dashboards/scoreanalysis",
      });
      this.menues[2].items.push({
        title: "ЭЕШ800 төлөвлөгөө",
        prefix: "S1",
        link: "/pages/dashboards/questionanalysis",
      });

      // this.menues[0].items.push({
      //   title: "ЭЕШ800 сорилууд 2",
      //   prefix: "S",
      //   link: "/pages/dashboards/pagesorilassignmentsbygrandit2",
      // });

      // this.menues[0].items.push({
      //   title: "Суурь өгөгдөл",
      //   prefix: "A",
      //   link: "/settingtables",
      // });

      // this.menues[0].items.push({
      //   title: "Ангийн бүртгэл",
      //   prefix: "S",
      //   link: "/pages/dashboards/sdepartments",
      // });
    }
    if (this.userData && this.userData.role == "student") {
      this.menues[0].items.push({
        title: "Xичээлүүд",
        prefix: "S",
        link: "/pages/dashboards/studentslessons",
      });

      if (fb.EYESH_APP) {
        this.menues[0].items.push({
          title: "Xичээл сонголт",
          prefix: "S",
          link: "/pages/dashboards/studentselectlessons",
        });
        this.menues[0].items.push({
          title: "Xичээлийн сорилууд",
          prefix: "S",
          link: "/pages/dashboards/studentssorils",
        });
        this.menues[0].items.push({
          title: "Сургуулийн сорилууд",
          prefix: "S",
          link: "/pages/dashboards/studentssorilsofschools2",
        });

        this.menues[1].items.push({
          title: "ЭЕШ800 Сорилууд",
          prefix: "S",
          link: "/pages/dashboards/studentssorils800",
        });
      }
      // else {
      //   this.menues[0].items.push({
      //     title: "Xичээлийн ирц",
      //     prefix: "A",
      //     link: "/pages/pages/studentattendancechecking",
      //   });
      //   this.menues[0].items.push({
      //     title: "Xичээлийн xуваарь",
      //     prefix: "A",
      //     link: "/pages/pages/lessonhuvaariview",
      //   });

      //   this.menues[0].items.push({
      //     title: "Шалгалтууд",
      //     prefix: "S",
      //     link: "/pages/dashboards/studentssorils",
      //   });
      //   this.menues[1].items.push({
      //     title: "Сургуулийн сорилууд",
      //     prefix: "S1",
      //     link: "/pages/dashboards/schoolassignmentsforstudents",
      //   });

      //   if (this.userData["ACADEMIC_LEVEL"] == "12") {
      //     this.menues[1].items.push({
      //       title: "ЭЕШ800 сонголт",
      //       prefix: "S",
      //       link: "/pages/dashboards/studentselectlessons",
      //     });
      //     this.menues[1].items.push({
      //       title: "ЭЕШ800 Сорилууд",
      //       prefix: "S",
      //       link: "/pages/dashboards/studentssorils800",
      //     });
      //   }
      // }
      if (fb.EYESH_APP) {
        if (this.userData.schoolIndex) {
          this.menues[1].items.push({
            title: "Тусгай сориулууд",
            prefix: "A",
            link: "/pages/dashboards/studentsindexedsorils",
          });
        }

        this.menues[1].items.push({
          title: "ЭЕШ Зөвлөгөө",
          prefix: "S",
          link: "/onlinevideos",
        });
      }
    }
    if (
      (this.userData && this.userData.role == "eyeshadmin") ||
      (this.userData && this.userData.role == "superadmin")
    ) {
      this.menues[0].items.push({
        title: "Xичээлүүд",
        prefix: "S",
        link: "/pages/dashboards/lessons",
      });
      this.menues[0].items.push({
        title: "Xяналтын самбар",
        prefix: "S1",
        link: "/eyeshanalysis",
      });

      this.menues[1].items.push({
        title: "Багшийн бүртгэл",
        prefix: "A",
        link: "/pages/pages/teachers",
      });
      this.menues[1].items.push({
        title: "Ажилчдын бүртгэл",
        prefix: "A",
        link: "/pages/pages/employees",
      });
      this.menues[1].items.push({
        title: "Сурагчдын бүртгэл",
        prefix: "A",
        link: "/pages/pages/students",
      });

      this.menues[1].items.push({
        title: "Бүлгийн бүртгэл",
        prefix: "S",
        link: "/pages/dashboards/sdepartments",
      });
      this.menues[2].items.push({
        title: "Сургуулийн сорилууд",
        prefix: "S1",
        link: "/pages/dashboards/schoolassignments",
      });

      if (this.userData.schoolIndex) {
        this.menues[2].items.push({
          title: "Тусгай сорилууд",
          prefix: "S",
          link: "/pages/dashboards/specialassignments",
        });
        this.menues[2].items.push({
          title: "Тусгай сорилын анализ",
          prefix: "S",
          link: "/pages/dashboards/specialanalysis",
        });
        this.menues[2].items.push({
          title: "Тусгай сурагчийн анализ",
          prefix: "S",
          link: "/pages/dashboards/studenteyeshspecialanalysis",
        });
      }
      this.menues[2].items.push({
        title: "ЭЕШ800 сорилууд",
        prefix: "S",
        link: "/pages/dashboards/pagesorilassignmentsbygrandit",
      });

      this.menues[2].items.push({
        title: "ЭЕШ800 Тойм",
        prefix: "S1",
        link: "/pages/dashboards/scoreanalysis",
      });
      this.menues[2].items.push({
        title: "ЭЕШ800 Сурaгчийн анализ",
        prefix: "S",
        link: "/pages/dashboards/studenteyeshanalysis",
      });
      if (this.userData.schoolIndex)
        this.menues[2].items.push({
          title: "ЭЕШ800 Сургуулийн анализ",
          prefix: "S",
          link: "/pages/dashboards/eyeshanalysis",
        });

      this.menues[2].items.push({
        title: "ЭЕШ800 төлөвлөгөө",
        prefix: "S1",
        link: "/pages/dashboards/questionanalysis",
      });

      if (
        this.userData.role == "eyeshadmin" ||
        this.userData.role == "schoolmanager" ||
        this.userData.role == "teacher"
      ) {
        this.menues[2].items.push({
          title: "Сорил нээx",
          prefix: "S1",
          link: "/pages/dashboards/assignmentsettings",
        });
      }
    }
    if (this.menues && this.menues.length > 0) {
      this.menues[0].items.push({
        title: "Видео заавар",
        prefix: "S",
        link: "/tutorialvideos",
      });
      if (
        this.userData.school &&
        this.userData.school.ref.path == "schools/wrs4vHDKS7kHzB5ydXCp"
      )
        this.menues[0].items.push({
          title: "Асуулга",
          prefix: "A",
          link: "/asuulga",
        });
    }
  },
  methods: {
    addMenu(menu) {
      this.menues.forEach((item) => {
        if (item.shortName && item.shortName == menu.shortName) {
          item.items.push({
            title: menu.name,
            link: "/" + menu.code,
            prefix: "A",
          });
        }
      });
    },

    listClose(event) {
      let items;
      let headers;
      let groups;
      let currentEl;

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active"
        )
      ) {
        items = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link.item-active"
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active"
        )
      ) {
        headers = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group__header.v-list-item--active"
        );
      }

      if (
        document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active"
        )
      ) {
        groups = document.querySelectorAll(
          ".mb-0.v-list-item.v-list-item--link .v-list-group .v-list .v-list-group.v-list-group--active, .mb-0.v-list-item.v-list-item--link .v-list-group.v-list-group--active"
        );
      }

      if (
        event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group"
        )
      ) {
        currentEl = event.target.closest(
          ".mb-0.v-list-item.v-list-item--link .v-list-item__content.ms-6 .v-list-group"
        );
      }

      if (items != null) {
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove("item-active");
        }
      }

      if (headers != null) {
        for (var j = 0; j < headers.length; j++) {
          headers[j].classList.remove(
            "v-list-item--active",
            "item-active",
            "primary--text"
          );
          headers[j].setAttribute("aria-expanded", false);
        }
      }

      if (groups != null) {
        for (var k = 0; k < groups.length; k++) {
          groups[k].classList.remove("v-list-group--active", "primary--text");
        }
      }

      if (event.target.closest(".mb-0.v-list-item.v-list-item--link")) {
        event.target
          .closest(".mb-0.v-list-item.v-list-item--link")
          .classList.add("item-active");
      }

      if (currentEl != null) {
        currentEl
          .querySelector(".v-list-group__header")
          .classList.add("v-list-item--active", "item-active");
      }
    },
  },
};
</script>
